var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn"},_vm.listeners),[_c('span',{staticClass:"block"},[_vm._t("default",[_vm._v("Click")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }